import { render, staticRenderFns } from "./ServiceRadioGroups.vue?vue&type=template&id=45f5075d"
import script from "./ServiceRadioGroups.vue?vue&type=script&lang=js"
export * from "./ServiceRadioGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports